"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var system_1 = require("@xstyled/system");
var Frame = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), system_1.backgrounds, system_1.color, system_1.flexboxes, system_1.layout, system_1.positioning, system_1.shadows, system_1.space, system_1.overflow);
Frame.defaultProps = {
    width: 'auto',
    height: 'auto',
    bg: 'bg',
    boxShadow: 'out',
};
exports.default = Frame;
var templateObject_1;
//# sourceMappingURL=Frame.js.map